/* eslint-disable no-restricted-imports -- the wrapper module is the moment island during the shadow window; raw moment access is required to delegate the Moment side of the comparison. */
import momentTimezone from 'moment-timezone';

import { dayjsApi, formatSerializer, runShadow } from './shadow-runner';
import type { DomainNameType } from './subdomains';

type TagShapeType = { domain: DomainNameType; subdomain: string };

export function shadowTz(tags: TagShapeType) {
  return (input: Parameters<typeof momentTimezone.tz>[0], zone: string) => {
    return runShadow({
      op: 'tz',
      ...tags,
      inputs: [input, zone],
      computeMoment: () => momentTimezone.tz(input, zone),
      // Use the canonical `datetime.tz` (moment-parity: wall-time-in-zone for a
      // zoneless string, instant-preserving for a zone-bearing one) — the exact
      // call cutover code runs — rather than `datetime(input).tz(zone)`, which read
      // a zoneless string in the runner's zone and diverged from moment.tz for any
      // cross-zone viewer (WORK-6365 Defect B).
      computeDayjs: () =>
        dayjsApi.datetime.tz(
          input as Parameters<typeof dayjsApi.datetime.tz>[0],
          zone
        ),
      serialize: formatSerializer,
    });
  };
}
